"use client";

import { useEffect, useState } from "react";

// Module-level cache for cookie values
const cookieCache: Record<string, string | undefined> = {};

const useCookie = (name: string = "location") => {
  const [cookie, setCookie] = useState<string>();

  useEffect(() => {
    // If value is cached, use it and skip fetch
    if (cookieCache[name] !== undefined) {
      setCookie(cookieCache[name]);
      return;
    }
    fetch(`/api/get-cookie/?name=${name}`, { cache: "force-cache" })
      .then((res) => res.json())
      .then((data) => {
        cookieCache[name] = data.value;
        setCookie(data.value);
      });
  }, [name]);

  return cookie;
};

export default useCookie;
